<template>
  <div class="product-faqs">
    <div class="container">
      <h3 v-if="heading"
          class="product-faqs__heading">
        {{ heading }}
      </h3>
      <tabbed-layout id="product-faqs">
        <template #selector="{currentTab, changeTab, ...props}">
          <dropdown-tab-selector id="product-faqs"
                                 :value="currentTab"
                                 v-bind="props"
                                 label="FAQs"
                                 mobile-dropdown
                                 @tab-selected="(val) => changeTab(val)">
          </dropdown-tab-selector>
        </template>
        <tab-item v-for="(faq, index) in faqs"
                  :key="index"
                  :label="faq.question">
          <h4 class="product-faqs__question">
            {{ faq.question }}
          </h4>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div v-html="faq.answer" />
        </tab-item>
      </tabbed-layout>
    </div>
  </div>
</template>

<script>
import { TabbedLayout, TabItem } from "spiritweb.packages.web-account";
import DropdownTabSelector from "~/Components/Products/Tabs/DropdownTabSelector.vue";

export default {
  name: "ProductFaqs",
  components: {
    TabbedLayout,
    TabItem,
    DropdownTabSelector,
  },
  props: {
    faqs: {
      type: Array,
      default: null,
    },
    heading: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="less">
.product-faqs {
  background-color: #F0ECE6;
  padding: 40px 80px;
  max-width: 1500px;
  margin: 0 auto;

  @media ( max-width: 992px ) {
    padding: 40px 0;

    .container {
      padding: 0 15px;
    }
  }

  @media ( max-width: 767px ) {
    padding: 40px 15px;
  }

  .tabbed-layout {
    display: flex;

    @media ( max-width: 767px ) {
      flex-direction: column;
    }

    &__content {
      padding: 10px 80px;

      @media ( max-width: 767px ) {
        padding: 10px 0;
      }
    }
  }

  &__question {
    color: #333;
    font-size: 1.38rem;
    font-weight: 500;
  }

  &__heading {
    font-weight: 500;
    font-size: 2.25rem;
    color: #333;
    margin-bottom: 20px;
  }

  .tab-container {
    display: flex;
    flex-direction: column;
    min-width: 285px;
    width: 285px;

    @media ( max-width: 767px ) {
      width: 100%;
    }
  }

  .tab-container .tab {
    width: 100% !important;
    border-bottom: 1px solid #aaa;
    position: relative;
    font-size: 1rem;
    font-weight: 500;
    line-height: 18px;
    color: #aaa;
    padding: 10px 0;

    &:hover {
      cursor: pointer;
    }

    &--selected {
      color: #555;

      &::before {
        content: "";
        display: block;
        position: absolute;
        left: -12px;
        width: 4px;
        height: 18px;
        background-color: #333;
      }
    }
  }
}
</style>
